// Vue Commentaires — montage du module transverse @gs/feedback (ONBOARDING-NOUVELLE-APP
// Phase 1). Toute la logique vit dans le package ; la vue ne fait que monter FeedbackPage
// (capability-aware : bandeau 503 pre-migration, masquage 404 — AUCUN controle mort).
// Deep-link `?ticket=<id>` (cloche ntf) : la vue traduit query param <-> selection.
import { useSearchParams } from 'react-router-dom';
import { FeedbackPage } from '@gs/feedback/client';
import { useAuth } from '@gs/auth';

export default function FeedbackView() {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <div className="space-y-3">
      <FeedbackPage
        enabled={!!user}
        openTicketId={searchParams.get('ticket')}
        onOpenTicketChange={(id) => setSearchParams(id ? { ticket: id } : {}, { replace: true })}
      />
    </div>
  );
}
